<template>
    <ContentLayout>
        <v-row>
            <v-col cols="12" md="6" lg="5" xl="4">
                <v-card elevation="8" :class="{ 'mx-4 my-4': $vuetify.breakpoint.mdAndUp }" color="white" tile>
                    <v-card-title class="secondary-font text-h5 text-sm-h4 primary--text text-uppercase">{{ $t("pages.contact.contact-us") }}</v-card-title>
                    <v-divider></v-divider>
                    <v-img
                        height="320"
                        src="/assets/img/gallery/1.jpg"
                    ></v-img>
                    <v-divider></v-divider>
                    <v-card-text class="text-body-1">
                        <v-list color="transparent">
                            <v-list-item :href="_env.VUE_APP_ADDRESS_LINK" target="_blank">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-map-marker
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ _env.VUE_APP_ADDRESS }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item :href="'tel:' + _env.VUE_APP_PHONE" target="_blank">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-phone
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ _env.VUE_APP_PHONE }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item :href="'mailto:' + _env.VUE_APP_EMAIL" target="_blank">
                                <v-list-item-icon>
                                    <v-icon color="primary">
                                        mdi-email
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ _env.VUE_APP_EMAIL }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>

                <v-card elevation="8" :class="{ 'mx-4 my-4': $vuetify.breakpoint.mdAndUp }" class="mt-8" color="white" tile>
                    <v-card-title class="secondary-font text-h5 text-sm-h4 primary--text text-uppercase">
                        {{ $t('pages.contact.entrance.title') }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <p class="text-uppercase ma-4">
                        {{ $t('pages.contact.entrance.text') }}
                    </p>
                    <v-divider></v-divider>
                    <v-img
                        height="320"
                        src="/assets/img/gallery/21.jpg"
                    ></v-img>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="7" xl="8">
                <v-card elevation="8" :class="{ 'mx-4 my-4': $vuetify.breakpoint.mdAndUp }" tile>
                    <v-sheet color="secondary" height="440px" id="map-wrapper">
                        <div id="map">
                            <iframe
                                width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                                :src="'https://maps.google.com/maps?width=100%25&amp;height=100%25&amp;hl=' + $i18n.locale + '&amp;q=' + _env.VUE_APP_ADDRESS + '&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed'"
                            ></iframe>
                        </div>
                        <v-row no-gutters class="fill-height" align="center" justify="center" id="map-loading">
                            <v-col cols="auto" class="text-h2">
                                <!--<span class="main-font">Map</span>-->
                                <v-progress-circular indeterminate size="80"></v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-card>

                <v-form ref="form" @submit.prevent @submit="submit">
                    <v-card elevation="8" :class="{ 'mx-4 my-4': $vuetify.breakpoint.mdAndUp }" class="mt-8" color="white" tile>
                        <v-card-title class="secondary-font text-h5 text-sm-h4 primary--text text-uppercase">{{ $t("pages.contact.message") }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="text-body-1">
                            <v-row>
                                <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        :label="$t('pages.contact.form.first_name')"
                                        v-model="form.first_name"
                                        :rules="[ $data.customRules.required ]" maxlength="30" :disabled="submitting"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        :label="$t('pages.contact.form.last_name')"
                                        v-model="form.last_name"
                                        :rules="[ $data.customRules.required ]" maxlength="30" :disabled="submitting"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        :label="$t('pages.contact.email')"
                                        v-model="form.email"
                                        :rules="[ $data.customRules.required, $data.customRules.email ]" :disabled="submitting"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        :label="$t('pages.hiring.form.phone')"
                                        v-model="form.phone"
                                        v-mask="'(###) ###-####'"
                                        :rules="[ $data.customRules.required, $data.customRules.phone ]" :disabled="submitting"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea
                                        :label="$t('pages.contact.form.message')"
                                        v-model="form.message"
                                        counter="1000" auto-grow rows="1"
                                        :rules="[ $data.customRules.required ]" maxlength="1000" :disabled="submitting"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" large type="submit" :loading="submitting" tile>
                                <v-icon left>mdi-send</v-icon>{{ $t('pages.contact.submit.btn') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </ContentLayout>
</template>

<script>
    import ContentLayout from "@/components/layouts/Content";

    export default {
        name: "contact-view",
        components: { ContentLayout },
        data: () => ({
            submitting: false,
            form: {
                first_name: null,
                last_name: null,
                phone: null,
                email: null,
                message: null
            }
        }),
        methods: {
            submit() {
                if(this.$refs && this.$refs.form && this.$refs.form.validate()) {
                    this.submitting = true;
                    this._request("forms/contact", this.form).then(response => {
                        if(response.error) {
                            this.$root.snack.show({
                                //text: response.error,
                                text: this.$i18n.t("pages.contact.submit.error"),
                                icon: "mdi-alert-circle",
                                color: "error"
                            });
                            return;
                        }
                        
                        this.form.message = null;
                        this.$refs.form.resetValidation();
                        
                        this.$root.snack.show({
                            text: this.$i18n.t("pages.contact.submit.success"),
                            icon: "mdi-check",
                            color: "success"
                        });

                    }).finally(() => {
                        this.submitting = false;
                    });
                } else {
                    this.$root.snack.show({
                        text: this.$i18n.t("form-validation-error"),
                        icon: "mdi-alert-circle",
                        color: "error"
                    });
                }
            }
        }
    };
</script>

<style scoped>
    #map-wrapper {
        position: relative;
    }
    #map {
        z-index: 2;
        position: absolute;
        top: 0px; bottom: 0px; left: 0px; right: 0px;
        
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }
    #map-loading {
        z-index: 1;
    }
</style>